import React from 'react'
import { SelectInput } from 'react-admin'

export const COUNTRY_CHOICES = [
  { id: 'BRA', name: 'Brasil' },
  { id: 'MEX', name: 'México' },
  { id: 'CHL', name: 'Chile' },
  { id: 'COL', name: 'Colombia' }
]

const CountrySelect = props => {
  return (
    <SelectInput {...props} choices={COUNTRY_CHOICES}/>
  )
}

export default CountrySelect
